export const courseOrderQuantityLimitTranslationJP = {
  courseOrderQuantityLimit: {
    title: 'コース注文数制限設定',
    sub_title: 'こちらの設定は、コース詳細で「{{selectedLimitType.name}}」がONになったコースのみ適用されます。',
  },
  courseOrderQuantityLimitTitle: {
    restrictions: '制限内容',
    course: 'コース',
    order_quantity_limit_menu: '注文数制限メニュー',
  },
  courseOrderQuantityLimitButton: {
    course: '対象コース',
    order_quantity_limit_menu: '対象メニュー',
  },
  applicableCoursesModal: {
    title: '対象コース一覧',
    restrictions: '制限内容',
    quantity: '数量',
    add_button: '追加',
    delete_button: '削除',
    delete_title: '選択',
    menu_book_title: 'メニューブック',
    course_title: 'コース',
    info: '情報',
    delete_success: 'データを削除しました',
    delete_warning:
      '選択されたコースをリストから削除します。削除したコースは、コース詳細の注文数制限が「設定無し」になります。よろしいですか？',
  },
  addApplicableCoursesModal: {
    title: '対象コース追加',
    search: '絞り込み',
    menu_book_name: 'メニューブック名称',
    course_name: 'コース名称',
    narrow_down: '絞り込み',
    select_all: '全選択',
    cancel_all: '解除',
    reload: 'リロード',
    info: '情報',
    add_warning:
      'コースをリストに追加します。追加したコースは、コース詳細の注文数制限が変更になります。よろしいですか？',
  },
};
